import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { map } from "rxjs";

import {
	normalizeArabicIndicDigitsInValue,
	toLatinDigits,
} from "@azm/core/utilities/normalize-arabic-indic-digits";

function normalizeFormData(body: FormData): FormData {
	const next = new FormData();
	body.forEach((value, key) => {
		if (typeof value === "string") {
			next.append(key, toLatinDigits(value));
			return;
		}
		next.append(key, value);
	});
	return next;
}

/** Ensure request params/body and JSON responses use Latin digits (0-9). */
export const latinDigitsInterceptor: HttpInterceptorFn = (req, next) => {
	let nextReq = req;

	if (req.params.keys().length > 0) {
		let params = req.params;
		let paramsChanged = false;
		for (const key of params.keys()) {
			const values = params.getAll(key) ?? [];
			const normalized = values.map((value) => toLatinDigits(value));
			if (normalized.some((value, index) => value !== values[index])) {
				paramsChanged = true;
				params = params.delete(key);
				for (const value of normalized) {
					params = params.append(key, value);
				}
			}
		}
		if (paramsChanged) {
			nextReq = nextReq.clone({ params });
		}
	}

	const body = nextReq.body;
	if (body instanceof FormData) {
		nextReq = nextReq.clone({ body: normalizeFormData(body) });
	} else if (
		body != null &&
		!(body instanceof Blob) &&
		!(body instanceof ArrayBuffer) &&
		!(body instanceof File)
	) {
		nextReq = nextReq.clone({ body: normalizeArabicIndicDigitsInValue(body) });
	}

	return next(nextReq).pipe(
		map((event) => {
			if (!(event instanceof HttpResponse) || event.body == null) {
				return event;
			}
			if (typeof event.body === "string") {
				return event.clone({ body: toLatinDigits(event.body) });
			}
			if (typeof event.body === "object") {
				return event.clone({ body: normalizeArabicIndicDigitsInValue(event.body) });
			}
			return event;
		}),
	);
};
